import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-md'
          : 'bg-[#8B1538]'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-5 md:py-6">
          {/* Logo - Extra Large */}
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img
              src="https://customer-assets.emergentagent.com/job_telfer-bridge/artifacts/8ou8i6z4_tgs-red.png"
              alt="Telfer Gateway Society Logo"
              className="h-20 sm:h-24 md:h-32 w-auto object-contain"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('mission')}
              className={`transition-colors duration-200 font-medium ${
                isScrolled ? 'text-slate-700 hover:text-[#8B1538]' : 'text-white/90 hover:text-white'
              }`}
            >
              Mission
            </button>
            <button
              onClick={() => scrollToSection('industries')}
              className={`transition-colors duration-200 font-medium ${
                isScrolled ? 'text-slate-700 hover:text-[#8B1538]' : 'text-white/90 hover:text-white'
              }`}
            >
              Industries
            </button>
            <button
              onClick={() => scrollToSection('events')}
              className={`transition-colors duration-200 font-medium ${
                isScrolled ? 'text-slate-700 hover:text-[#8B1538]' : 'text-white/90 hover:text-white'
              }`}
            >
              Events
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`transition-colors duration-200 font-medium ${
                isScrolled ? 'text-slate-700 hover:text-[#8B1538]' : 'text-white/90 hover:text-white'
              }`}
            >
              Contact
            </button>
            <Button
              onClick={() => scrollToSection('events')}
              className={`transition-all duration-200 shadow-md hover:shadow-lg ${
                isScrolled
                  ? 'bg-[#8B1538] hover:bg-[#6B1028] text-white'
                  : 'bg-white text-[#8B1538] hover:bg-slate-50'
              }`}
            >
              Get Involved
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className={`md:hidden transition-colors ${
              isScrolled ? 'text-slate-700 hover:text-[#8B1538]' : 'text-white hover:text-white/80'
            }`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-white/20 bg-[#8B1538]">
            <nav className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('mission')}
                className="text-white/90 hover:text-white transition-colors duration-200 font-medium text-left px-2"
              >
                Mission
              </button>
              <button
                onClick={() => scrollToSection('industries')}
                className="text-white/90 hover:text-white transition-colors duration-200 font-medium text-left px-2"
              >
                Industries
              </button>
              <button
                onClick={() => scrollToSection('events')}
                className="text-white/90 hover:text-white transition-colors duration-200 font-medium text-left px-2"
              >
                Events
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-white/90 hover:text-white transition-colors duration-200 font-medium text-left px-2"
              >
                Contact
              </button>
              <Button
                onClick={() => scrollToSection('events')}
                className="bg-white text-[#8B1538] hover:bg-slate-50 transition-all duration-200 w-full"
              >
                Get Involved
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
